import i18n from '@atpoint/atpjs/helpers/i18n'
import config from '@forms/config'
import { Box } from '@material-ui/core'
import type React from 'react'
import { H2, Link, P } from 'swisscard/components/typography'

type ConfirmationProps = {
  confirmation_description: string
  confirmation_title: string
  confirmation_button_text: string
  confirmation_button_url: string
}

const t = i18n.prefix(['confirmation'])

const Confirmation: React.FC<ConfirmationProps> = (props: ConfirmationProps) => {
  const { confirmation_title, confirmation_description, confirmation_button_text, confirmation_button_url } = props
  const confirmationButtonText = confirmation_button_text || t(['backHome'])
  const confirmationButtonUrl = confirmation_button_url || config.ESCAPE_URL

  return (
    <>
      <Box pt={5} pb={1}>
        {confirmation_title && <H2 noMargin>{confirmation_title}</H2>}
        {confirmation_description && <P>{confirmation_description}</P>}
      </Box>

      <Link href={confirmationButtonUrl}>{confirmationButtonText}</Link>
    </>
  )
}

export default Confirmation
